import React from "react";
import { Box, Typography, CardContent, Divider } from "@mui/material";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { castEnumForDisplay } from "../../../helpers/enumHelpers";

export interface SimpleCountStatsDto {
  total: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any; // To support extra flexible keys like "activeBranches" etc.
}

interface SimpleStatWidgetProps {
  entityType: string;
  data: SimpleCountStatsDto;
}

const SimpleStatWidget: React.FC<SimpleStatWidgetProps> = ({
  entityType,
  data,
}) => {
  const meta = getEntityMeta(entityType);
  const Icon = meta.icon;

  return (
    <StyledCard
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <CardContent sx={{ textAlign: "center" }}>
        <Box
          sx={{
            display: "inline-flex",
            p: 2,
            borderRadius: "50%",
            bgcolor: `${meta.color}15`,
            color: meta.color,
            mb: 2,
          }}
        >
          <Icon fontSize="large" />
        </Box>
        <Typography variant="h4" sx={{ fontWeight: "bold" }}>
          {data.total}
        </Typography>
        <Typography variant="body1" sx={{ color: "text.secondary", mb: 1 }}>
          {castEnumForDisplay(meta.title)}
        </Typography>

        {Object.keys(data).length > 1 && (
          <>
            <Divider sx={{ my: 2 }} />
            <Box sx={{ display: "flex", justifyContent: "space-around" }}>
              {Object.entries(data).map(([key, val]) => {
                if (key === "total") return null;
                return (
                  <Box key={key}>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "text.secondary",
                        textTransform: "capitalize",
                      }}
                    >
                      {key.replace(/([A-Z])/g, " $1").trim()}
                    </Typography>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                      {val}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </>
        )}
      </CardContent>
    </StyledCard>
  );
};
export default SimpleStatWidget;
